<app-spinner *ngIf="isLoading || isNavigating" [message]="message"></app-spinner>
<div class="main-router-container" [@appFade]="animationState">
  <router-outlet></router-outlet>
</div>


